<script>
import VsTableHeading from './VsTableHeading';

export default {
  components: {
    VsTableHeading,
  },
  props: {
    processing: Boolean,
    headings: Array,
    sortColumn: String,
    sortDirection: Number,
    headerTop: Number,
  },
};
</script>

<template lang='pug'>
.vs-table__header(
  ref='header',
  :style='{ top: `${headerTop}px` }',
)
  .vs-table__header-row
    vs-table-heading(
      v-for='heading in headings',
      :key='heading',
      :heading='heading',
      :processing='processing',
      :sort-column='sortColumn',
      :sort-direction='sortDirection',
      @header-action='$emit("header-action", $event)',
      @sort='$emit("sort", $event)',
      @help='$emit("help", $event)',
    )
</template>